import { observer } from 'mobx-react-lite'

import { Icon } from '@mxenabled/mxui'

import { ResponsiveButton, useGlobalCopyStore } from '../../../../common'
import { useEvent, useTransactionStore } from '../../../../common'

import { type Transaction } from '../../../../core'
import { exportTransactionsToCSV } from '../../../../core/utils/TransactionUtils'

import { ON_CLICK_EVENTS } from '../../../constants/OnClickEvents'

interface ExportCsvActionProps {
  filter?: (t: Transaction) => boolean
}

const ExportCsvAction = ({ filter }: ExportCsvActionProps) => {
  const { onEvent } = useEvent()
  const { tags, sortedTransactions } = useTransactionStore()
  const { transactions: copy } = useGlobalCopyStore()

  const handleExport = () => {
    onEvent(ON_CLICK_EVENTS.ON_TRANSACTION_EXPORT_CSV_CLICK)
    exportTransactionsToCSV(filter ? sortedTransactions.filter(filter) : sortedTransactions, tags)
  }

  return (
    <div className="mx-txn-export-csv-action">
      <ResponsiveButton
        icon={<Icon name="open_in_new" />}
        label={copy.export_csv_btn}
        onClick={handleExport}
        tooltipText={copy.export_csv_title}
      />
    </div>
  )
}

export default observer(ExportCsvAction)
